const theme = {
  id: "xmen",
  primary: "#FFC947", //Yellow
  secondary: "#OA1931", //Dark Blue
  background: "#185ADB", //light blue
  third: "#EFEFEF", // light gray
};

export default theme;
